// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import { registerLicense } from '@syncfusion/ej2-base'

// Registering Syncfusion license key
registerLicense(process.env.VUE_APP_SYNCFUSION_SCHEDULER_LICENSE_KEY)

// Create the app instance
const app = createApp(App)

// Use essential plugins (Store, Router) BEFORE waiting for the router
app.use(store)
app.use(router)

// Use other plugins/components
app.use(CoreuiVue)
app.provide('icons', icons)
app.component('CIcon', CIcon)

// Wait for the router to complete its initial navigation before mounting
router.isReady().then(() => {
  app.mount('#app')
})
